import { Table } from '@tanstack/react-table';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa6';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';
import { TABLE_ROW_NUMBER_OPTIONS } from '../../../constants/settings';
import { createRangeArray } from '../../../utils/commonFunctions';
import AcademiaTableSelect from '../Inputs/AcademiaTableSelect';
import PaginationButton from './PaginationButton';

const Pagination = ({
  table,
  currentPage,
  rowsPerPage,
}: {
  table: Table<any>;
  currentPage: number;
  rowsPerPage: number;
}) => {
  // Display a limited number of pages when needed
  const startPage = Math.max(1, currentPage - 3);
  const endPage = Math.min(startPage + 4, table.getPageCount());

  // rendering custom pagination component here
  return (
    <div className='bg-legal-dark-blue shadow-academia-sm py-4 px-5 flex flex-col lg:flex-row items-center justify-between gap-4 rounded-xl'>
      <div className='flex flex-col lg:flex-row items-center gap-2'>
        <p className='text-lg text-base-white font-medium'>Rows Per Page: </p>
        <AcademiaTableSelect
          options={TABLE_ROW_NUMBER_OPTIONS}
          onChangeHandler={(option) => table.setPageSize(+option)}
        />
      </div>

      <div className='flex flex-col md:flex-row items-center gap-2'>
        <div>
          <p className='text-lg font-medium text-base-white'>
            Showing{' '}
            <span className='font-semibold text-legal-brown'>
              {currentPage * rowsPerPage + 1}-
              {(currentPage + 1) * rowsPerPage < table.getRowCount()
                ? (currentPage + 1) * rowsPerPage
                : table.getRowCount()}
            </span>{' '}
            of{' '}
            <span className='font-semibold text-legal-brown'>
              {table.getRowCount()}
            </span>
          </p>
        </div>

        <div className='flex items-center gap-2'>
          <button
            onClick={() => table.firstPage()}
            className='text-legal-brown hover:text-base-gray duration-300 disabled:opacity-45 disabled:cursor-not-allowed'
            disabled={!table.getCanPreviousPage()}
          >
            <FiChevronsLeft className='h-7 w-7' />
          </button>
          <button
            onClick={() => table.previousPage()}
            className='text-legal-brown hover:text-base-gray duration-300 disabled:opacity-45 disabled:cursor-not-allowed'
            disabled={!table.getCanPreviousPage()}
          >
            <FaChevronLeft />
          </button>

          {createRangeArray(startPage, endPage).map((i) => (
            <PaginationButton
              key={i}
              index={i}
              currentPage={currentPage + 1}
              onPageChange={(page) => table.setPageIndex(page - 1)}
            >
              {i}
            </PaginationButton>
          ))}

          <button
            onClick={() => table.nextPage()}
            className='text-legal-brown hover:text-base-gray duration-300 disabled:opacity-45 disabled:cursor-not-allowed'
            disabled={!table.getCanNextPage()}
          >
            <FaChevronRight />
          </button>
          <button
            onClick={() => table.lastPage()}
            className='text-legal-brown hover:text-base-gray duration-300 disabled:opacity-45 disabled:cursor-not-allowed'
            disabled={!table.getCanNextPage()}
          >
            <FiChevronsRight className='h-7 w-7' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
